import React from "react";
import { FaRoad, FaSchool, FaGraduationCap, FaHospital, FaBook, FaUserMd } from "react-icons/fa";

const places = [
  {
    name: "National Highway (NH-12)",
    distance: "1.5 Km",
    time: "4 Min",
    icon: <FaRoad />,
  },
  {
    name: "Julien Day School",
    distance: "1.5 Km",
    time: "4 Min",
    icon: <FaSchool />,
  },
  {
    name: "B.T. College",
    distance: "2 Km",
    time: "5 Min",
    icon: <FaGraduationCap />,
  },
  {
    name: "Vivacity Hospital",
    distance: "3.5 Km",
    time: "10 Min",
    icon: <FaHospital />,
  },
  {
    name: "Calcutta Public School, Barasat",
    distance: "5 Km",
    time: "12 Min",
    icon: <FaBook />,
  },
  {
    name: "Narayana Hospital",
    distance: "5 Km",
    time: "12 Min",
    icon: <FaUserMd />,
  },
];

const NearbyPlaces = () => {
  return (
    <div className="nearby-container">
      {places.map((place, index) => (
        <div className="place-item" key={index}>
          <div className="icon">{place.icon}</div>

          <div className="details">
            <h3>{place.name}</h3>
            <div className="meta">
              <span>📍 {place.distance}</span>
              <span>⏱ {place.time}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NearbyPlaces;